import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Formatação de dinheiro: implementação única em @mustauto/utils, com a
// unidade no nome.
export { formatReais, formatCentavos } from '@mustauto/utils';

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('pt-BR').format(value);
}

export function formatPercent(value: number): string {
  return `${value.toFixed(2)}%`;
}
